<template>
  <q-no-ssr>
    <div class="q-mb-xl">
      <div class="container-global row">
        <div class="col-sm-12 col-md-7 order-last order-md-first">
          <section class="search-section" role="search" aria-label="بحث المواقع">
            <div class="justify-center">
              <div class="col-11 col-md-12 col-lg-12">
                <div class="search-section__label">
                  <h1 class="fs-1 text-weight-bold q-mb-sm" :class="lessThanSixhundred ? 'text-center' : ''">
                    قيّم وشارك تجربتك لتحسين المواقع و المنتجات الرقمية
                  </h1>
                  <h2 class="fs-6 text-weight-medium q-my-lg q-my-md-xl" fetchpriority="high">
                    ساهم في تحسين التجربة الرقمية من خلال المشاركة برأيك وتجربتك أثناء التفاعل مع المواقع للكشف عن
                    المشاكل وتحسين تجربة المستخدم.
                  </h2>
                  <h2 class="text-h6 q-ma-none text-bold q-mb-xs">
                    <span class="text-highlighted">
                      استكشف آراء وتقييمات المستخدمين لأي موقع على الإنترنت
                    </span>
                  </h2>
                </div>
              </div>
            </div>
            <div class="row flex-center">
              <div class="full-width">
                <template v-if="gtFourThreeFive">
                  <div class="search-section__input relative-position q-mb-md shadow-2" 
                     role="combobox" aria-haspopup="listbox" aria-controls="searchList" :aria-expanded="showResults"
                    :aria-activedescendant="activeIndex >= 0 ? `result-${activeIndex}` : undefined">
                    <q-input  outlined class="search_input text-h5 input-with-clickthrough" :class="{
                          no_bottom_border: showResults && resultArr.length > 0,
                        }" v-model="url" id="searchInput" @update:model-value="handleInput" @keydown="handleKeydown"
                      :dense="lteFourThreeFive" placeholder="جرّب  الموقع هنا..."
                      aria-label="ادخل اسم الموقع للبحث">
                      <template v-slot:prepend>
                        <q-icon class="icon icon-search" size="md" />
                      </template>
                      <template v-slot:append>
                        <q-btn icon="icon-spark" class="primary_btn search_btn rounded-8" label="بحث"
                          @click="getAllSearchResults" aria-label="search" />
                      </template>
                    </q-input>

                    <ul class="result_list" ref="searchList" id="searchList" role="listbox"
                      v-if="showResults && resultArr.length > 0">
                      <li v-for="(item, index) in resultArr" :key="item.url"
                        class="result_content--wrapper text-left cursor-pointer"
                        :class="{ active: index === activeIndex }" role="option" :aria-selected="index === activeIndex"
                        @mouseenter="activeIndex = index" @click="selectResult">
                        <div class="result_content row items-center">
                          <q-img :src="item.favicon ? item.favicon : 'default.svg'" error-src="default.svg"
                            style="height: 25px; width: 24px; border-radius: 50%" class="q-mx-md" fit="contain"
                            no-spinner loading="lazy" :alt="item.name" />

                          <div>
                            <div class="site_name text-h5">{{ item.name }}</div>
                            <span class="site_link">{{ item.url }}</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <template v-if="!!homeStatsData?.domains">
                    <span class="sites-counter text-body1 text-grey-7 akwad-bold">
                      <i class="icon icon-globe"></i>&nbsp;
                      <span>لدينا أكثر من</span>
                      <AnimatedCounter style="color: #935117;" :target-number="homeStatsData?.domains || 0"
                        :duration="2000" />
                      <span>موقع مسجل</span>
                    </span>
                  </template>
                </template>

                <div class="search-section__input relative-position" v-if="lteFourThreeFive">
                  <div class="flex column mobile-input-border" :class="{
                        no_bottom_border: showResults && resultArr.length > 0,
                      }">
                    <div class="input-wrapper row items-center">
                      <div class="col">
                        <q-input borderless class="text-h5" v-model="url" id="search_input"
                          @update:model-value="handleInput" @keydown.enter.prevent="onSearch" debounce="200" dense
                          placeholder="جرّب أدخل الموقع هنا..." bottom-slots>
                        </q-input>
                      </div>
                    </div>
                    <div class="btn-wrapper">
                      <q-btn icon="icon-spark" class="primary_btn search_btn rounded-8 full-width" label="جـرّب"
                        @click="getAllSearchResults" :loading="loader" aria-label="search" />
                    </div>
                  </div>
                  <template v-if="!!homeStatsData?.domains">
                    <span class="text-body1 text-center inline-block full-width q-pt-md">
                      <i class="icon icon-globe"></i>&nbsp;
                      <span>لدينا أكثر من</span>
                      <AnimatedCounter :target-number="homeStatsData?.domains || 0" :duration="2000" />
                      <span>موقع مسجل</span>
                    </span>
                  </template>
                  <ul class="result_list" v-if="showResults && resultArr.length > 0">
                    <li v-for="(item, index) in resultArr" :key="item.url"
                      class="result_content--wrapper text-left cursor-pointer"
                      :class="{ active: index === activeIndex }" @mouseenter="activeIndex = index"
                      @click.capture="selectResult">
                      <div class="result_content row items-center">
                        <q-img :src="item.favicon ? item.favicon : 'default.svg'" error-src="default.svg"
                          style="height: 25px; width: 24px; border-radius: 50%" class="q-mx-md" fit="contain" no-spinner
                          loading="lazy" :alt="item.url" />
                        <div>
                          <div class="site_name text-h5">{{ item.name }}</div>
                          <span class="site_link text-h5">{{ item.url }}</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div class="col-sm-12 col-md-5 order-first order-md-last" :class="lessThanSixhundred ? 'full-width' : ''">
          <div class="hero-image q-pa-md-lg q-mx-md-xl q-mx-sm-none q-pt-md-xl q-mt-md q-mt-md-xl row">
            <HeroAnimation />
          </div>
        </div>
      </div>

      <br />
      <div class="container-global q-pt-xl q-mb-xl">
        <!-- <div class="text-center">
          <h3 class="text-h3 text-weight-medium q-mb-none q-mt-lg q-mb-xl"> </h3>
          <p class="q-ma-none q-mb-xl q-mt-sm text-bold text-h5">تصفح وشارك التقييمات بكل سهولة</p>
        </div> -->
        <div class="">
            <div class="header_section">
                <h3 class="header_section-title">
                  كيف تستخدم منصة أكواد
                </h3>
                <p class="header_section-description">
                    <!-- تجربة المستخدم الممتازة ما تفيد العميل فقط، بل تحسّن الأداء، وتقلل التكاليف، ونرفع الإيرادات،
                    وتدعم فرق العمل -->
                </p>
            </div>
        </div>
        <div class="row q-col-gutter-xl justify-between box-steps">
          <div class="col-12 col-md-3 relative-position">
            <q-card class="q-pa-md q-pl-xl rounded-8">
              <q-card-section>
                <div class="text-h6 text-grey-7">
                  <img class="image-step" src="../assets/images/home/home.svg" alt="second one" loading="lazy"
                    width="180" height="110">
                </div>
                <div class="text-h5 akwad-extraBold q-mb-sm q-mt-sm flex align-center" style="gap: 10px;">
                  <div class="number-step">1</div>
                  <div>
                    ابحث
                  </div>
                </div>
                <div class="text-h6 text-grey-7">
                  بالرابط كامل او بكلمة لها علاقة بالموقع
                </div>
              </q-card-section>
            </q-card>
          </div>

          <div class="col-12 col-md-3 relative-position">
            <q-card class="q-pa-md q-pl-xl rounded-8">
              <q-card-section>
                <div class="text-h6 text-grey-7">
                  <img class="image-step" src="../assets/images/home/search_result.svg" alt="second step" loading="lazy"
                    width="180" height="110">
                </div>
                <div class="text-h5 akwad-extraBold q-mb-sm q-mt-sm flex align-center" style="gap: 10px;">
                  <div class="number-step">2</div>
                  <div>
                    استعرض

                  </div>
                </div>
                <div class="text-h6 text-grey-7 flex aitems-center justif-center">
                  <span class="">
                    شاهد نتائج البحث اللي
                  </span>
                  &nbsp;
                  <span>
                    طلعت
                    <span>
                      <img src="../assets/icons/info.svg" alt="info" loading="lazy" width="14" height="14">
                      <q-tooltip anchor="top middle" self="bottom middle" :offset="[10, 10]"
                        class="bg-grey-1 text-grey-7 ">في حال البحث برابط الموقع كاملاً سيتم الأنتقال لصفحة
                        <br />
                        تقييمات الموقع مباشرة دون عرض صفحة نتائج البحث
                      </q-tooltip>

                    </span>

                  </span>
                </div>
              </q-card-section>
            </q-card>
          </div>

          <div class="col-12 col-md-3 relative-position">
            <q-card class="q-pa-md q-pl-xl rounded-8">
              <q-card-section>
                <div class="text-h6 text-grey-7">
                  <img class="image-step" src="../assets/images/home/reviews.svg" alt="step three" loading="lazy"
                    width="180" height="110">
                </div>
                <div class="text-h5 akwad-extraBold q-mb-sm q-mt-sm flex align-center" style="gap: 10px;">
                  <div class="number-step">3</div>
                  <div>
                    اكتشف
                  </div>
                </div>
                <div class="text-h6 text-grey-7">
                  تصفح تقييمات المستخدمين وتجاربهم
                </div>
              </q-card-section>
            </q-card>
          </div>

          <div class="col-12 col-md-3 relative-position">
            <q-card class="q-pa-md q-pl-xl rounded-8">
              <q-card-section>
                <div class="text-h6 text-grey-7">
                  <img class="image-step" src="../assets/images/home/share.svg" alt="step four" loading="lazy"
                    width="180" height="110">
                </div>
                <div class="text-h5 akwad-extraBold q-mb-sm q-mt-sm flex align-center" style="gap: 10px;">
                  <div class="number-step">4</div>
                  <div>
                    شارك
                  </div>
                </div>
                <div class="text-h6 text-grey-7">
                  تفاعل مع التقييمات وشاركها بسهولة
                </div>
              </q-card-section>
            </q-card>
          </div>
        </div>
      </div>
      <br />

      <aside class="container-global q-pt-lg" aria-label="إحصائيات المواقع">
        <div class="text-center">
          <h3 class="text-h3 text-weight-medium q-mb-none"></h3>
          <p class="q-ma-none q-mb-xl q-mt-sm text-bold text-h5"></p>
        </div>
        <div class="">
            <div class="header_section">
                <h3 class="header_section-title">
                  مواقع مختارة                </h3>
                <p class="header_section-description">
                  تم تقييمها من مستخدمين أداة أكواد
                </p>
            </div>
        </div>
        <div class="row q-col-gutter-lg">
          <template v-if="statisticsLoader">
            <div class="col-12 col-sm-6 col-md relative-position" v-for="(i, index) in Array(5)" :key="index">
              <div class="q-pa-sm q-card--bordered column items-end" v-if="index < 5" :title="i">
                <q-skeleton height="165px" width="100%" animation="fade" />
                <q-skeleton type="QBadge" class="q-mt-sm" animation="fade" width="100px" />
                <q-skeleton type="QChip" class="q-mt-sm" animation="fade" width="140px" />
              </div>
            </div>
          </template>
          <template v-else>
            <div class="col-12 col-sm-6 col-md relative-position"
              v-for="(item, index) in homeStatsData?.random_top_websites" :key="index">
              <div class="q-pa-sm q-card--bordered">
                <div @click.prevent="goTo(item?.url)" class="site_url akwad-medium cursor-pointer text-body1 text-dark">
                  <!-- <q-img style="min-height: 165px" class="rounded-borders" :src="item?.image
                        ? `${APP_BASE_URL}/${item?.image}`
                        : '/website-dummy.jpg'
                        " fit="cover" :width="lteThanSixFiveZero
                          ? '100%'
                          : lteThanOneZeroTwoFour
                            ? '60%'
                            : '100% '
                          " spinner-color="primary" loading="lazy"
                          alt="website-image"
                          /> -->
                  <q-img :src="getResponsiveImageUrl(item?.image)" style="min-height: 165px" class="rounded-borders"
                    fit="cover" :width="lteThanSixFiveZero
                          ? '100%'
                          : lteThanOneZeroTwoFour
                            ? '60%'
                            : '100% '" spinner-color="primary" loading="lazy" alt="website-image" />
                  <div class="row items-center q-mt-sm justify-end">
                    {{ item?.url ? item?.url : 'No Url' }}
                  </div>
                </div>
                <div class="rating_value--container row justify-end items-center">
                  <div class="value flex flex-center">
                    <q-rating v-model="item.average_rate" icon-half="icon-star-half" readonly color="yellow"
                      size="xs" />
                    <span class="akwad-bold text-h6 q-ml-sm">{{
                      item.average_rate
                      }}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </aside>

      <div>
        <br />  
        <div class=" q-pt-xl q-my-xl" role="application" aria-label="كيفية استخدام أكواد">
          <!-- <div class="text-center">
            <h3 class="q-ma-none text-bold"></h3>
            <h4 class="q-ma-none q-mt-sm text-bold text-h5"></h4>
          </div> -->
          <div class="">
            <div class="header_section">
                <h3 class="header_section-title">
                  حمل أداة اكواد                </h3>
                <p class="header_section-description">
                  تجربة المستخدم الممتازة ما تفيد العميل فقط، بل تحسّن الأداء، وتقلل التكاليف، وترفع الإيرادات،
                  وتدعم فرق العمل
                </p>
            </div>
        </div>
          <div class="row q-mt-xl container-global">
            <div class="row q-col-gutter-xl justify-between">
              <div class="col-12 col-md-4 relative-position">
                <q-card class="q-pa-md q-pl-xl rounded-8">
                  <div class="number">1</div>
                  <q-card-section>
                    <div class="text-h5 akwad-extraBold q-mb-sm">
                      أضف أداة أكواد
                    </div>
                    <div class="text-h6 text-grey-7">
                      قم بتثبيت
                      <q-btn role="link" size="lg" dense rounded-8 class="text-bold q-pa-none" style="padding-inline:4px"
                        color="white" label="أداة أكواد" text-color="primary"
                        href="https://chromewebstore.google.com/detail/akwad-ux-tool/moimamimapjopaapamoiciljeocjfddl" />
                      بسهولة على متصفحك للبدء في تقييم المواقع.
                    </div>
                  </q-card-section>
                </q-card>
              </div>
              <div class="col-12 col-md-4 relative-position">
                <q-card class="q-pa-md q-pl-xl rounded-8">
                  <div class="number">2</div>
                  <q-card-section>
                    <div class="text-h5 akwad-extraBold q-mb-sm">

                      التصفح والتقييم

                    </div>
                    <div class="text-h6 text-grey-7">
                      استخدم الأداة أثناء تصفحك لإرسال تقييمات بناءً على تجربتك.
                    </div>
                  </q-card-section>
                </q-card>
              </div>
              <div class="col-12 col-md-4 relative-position">
                <q-card class="q-pa-md q-pl-xl rounded-8">
                  <div class="number">3</div>
                  <q-card-section>
                    <div class="text-h5 akwad-extraBold q-mb-sm">

                      استكشف التقييمات

                    </div>
                    <div class="text-h6 text-grey-7">
                      اطلع على تقييمات المستخدمين وتجاربهم لتعزز من قراراتك &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    </div>
                  </q-card-section>
                </q-card>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="q-pt-xl q-my-xl q-mx-auto inline-padding-70 page-width ">
              <div class="text-center">
                <h3 class="q-ma-none text-bold">حمل  أكواد</h3>
                <h4 class="q-ma-none q-mt-sm q-mb-lg text-bold text-h5">وساهم في تحسين تجربة المستخدم
                  الرقمية</h4>
              </div>
              <div class="row q-col-gutter-xl justify-between box-steps">
                <div class="col-12 col-md-3 relative-position">
                    <q-card class="q-pa-md q-pl-xl rounded-8">
                      <q-card-section>
                        <div class="text-h6 text-grey-7">
                          <img class="image-step" src="../assets/images/home/google.svg" alt="">
                        </div>
                        <div class="text-h5 akwad-extraBold q-mb-sm q-mt-lg flex align-center" style="gap: 10px;">
                            <div class="number-step">1</div>
                            <div>
                              ثبت اللإضافة
                            </div>
                        </div>
                        <div class="text-h6 text-grey-7">
                          يمكنك تحميل الاضافة بكل سهولة من خلال الزر الموجود في أعلى اليسار (حمل أداة أكواد) &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                        </div>
                      </q-card-section>
                    </q-card>
                  </div>
                  <div class="col-12 col-md-3 relative-position">
                      <q-card class="q-pa-md q-pl-xl rounded-8">
                        <q-card-section>
                          <div class="text-h6 text-grey-7">
                            <img  class="image-step" src="../assets/images/home/extension.svg" alt="">
                          </div>
                          <div class="text-h5 akwad-extraBold q-mb-sm q-mt-lg flex align-center" style="gap: 10px;">
                              <div class="number-step">2</div>
                              <div>
                                إفتح الإضافة
                              </div>
                          </div>
                          <div class="text-h6 text-grey-7">
                              ستظهر أكواد جنب الاضافات , يمكنك فتحها من خلال الضغط عليها &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          </div>
                        </q-card-section>
                      </q-card>
                    </div>
                  <div class="col-12 col-md-3 relative-position">
                      <q-card class="q-pa-md q-pl-xl rounded-8">
                        <q-card-section>
                          <div class="text-h6 text-grey-7">
                            <img  class="image-step" src="../assets/images/home/review.svg" alt="">
                          </div>
                          <div class="text-h5 akwad-extraBold q-mb-sm q-mt-lg flex align-center" style="gap: 10px;">
                              <div class="number-step">3</div>
                              <div>
                                أكتب تقييمك
                              </div>
                          </div>
                          <div class="text-h6 text-grey-7">
                            إملئ حقول التقييم وستصبح جاهزا لارسال تقييمك &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          </div>
                        </q-card-section>
                      </q-card>
                    </div>
                  <div class="col-12 col-md-3 relative-position">
                      <q-card class="q-pa-md q-pl-xl rounded-8">
                        <q-card-section>
                          <div class="text-h6 text-grey-7">
                            <img  class="image-step" src="../assets/images/home/send.svg" alt="">
                          </div>
                          <div class="text-h5 akwad-extraBold q-mb-sm q-mt-lg flex align-center" style="gap: 10px;">
                              <div class="number-step">4</div>
                              <div>
                                أرسل تقييمك
                              </div>
                          </div>
                          <div class="text-h6 text-grey-7">
                            بظغطة زر يتم إرسال تقييمك , تهانينا لقد شاركت بأول تقييم لك  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          </div>
                        </q-card-section>
                      </q-card>
                    </div>
              </div>
            </div> -->
        <br />
        <EarnMoney />
        <!-- <div class="container-global q-mt-sm" role="application" aria-label="كيفية استخدام أكواد">
          <q-card class="my-card text-white text-center q-py-lg q-px-md rounded-8" style="background:  #5854ff">
            <q-card-section>
              <div class="text-h4 text-bold">عندك خبرة في التجربة الرقمية وحاب انك تشارك معنا نطورها بشكل أفضل؟</div>
            </q-card-section>

            <q-card-section class="q-pt-none">
              <q-btn size="lg" rounded-8 class="text-bold q-mt-md rounded-8" color="white" label="اكتشف المزيد"
                text-color="primary" to="/akwadion" />
            </q-card-section>
          </q-card>
        </div> -->
        <br />
        <div class="container-global q-my-xl" role="doc-acknowledgments"
          aria-label="الأسئلة الشائعة">
          <FAQSection :faqList="faqList" />
        </div>
      </div>
    </div>
  </q-no-ssr>
</template>
<script setup lang="ts">
import { ref, onMounted, onUnmounted, computed  ,  reactive} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { autoComplete, randomSites, search } from '@/services/search-service';
import { useLoaderStore } from '@/stores/loader';
import { useSearchStore } from '@/stores/search';
import type { ISearchAutoComplete } from '@/types/IHomeSearch';
import { handleErrorFunc } from '@/boot/error-handler';
import { useMeta, useQuasar, QCard, QCardSection, QNoSsr, QBtn, QIcon, QSkeleton, QRating } from 'quasar';
import { APP_BASE_URL } from '@/boot/axios';
import { ISiteCards } from '@/types/ISiteCards';
import MyToaster from '@/utils/toaster';
import HeroAnimation from '@/components/ui/HeroAnimatedComponent.vue';
import AnimatedCounter from '@/components/ui/AnimatedCounter.vue';
import ContentFAQSection from '@/components/content/ContentFAQSection.vue';
import FAQSection from '@/components/ui/FAQSection.vue';
import EarnMoney from '@/components/ui/EarnMoney.vue';

defineOptions({
 name: 'HomePage',
 preFetch: async ({ store }) : Promise<any> => {
    try {
      const randomSitesData = await randomSites();
      randomSitesData.data.random_top_websites = randomSitesData.data?.random_top_websites.slice(0, 5);
      const searchStore = useSearchStore(store);
      searchStore.setRandomSites(randomSitesData.data);
      // return {
      //   searchStore: {
      //     randomSites: randomSitesData.data
      //   }
      // };
    } catch (e) {
      console.log(e);
    }
  },

})

const route = useRoute();
useMeta(route.meta);
const $q = useQuasar();
const lteThanOneZeroTwoFour = computed( () => $q.screen.width < 1024)
const lteThanSixFiveZero = computed( () => $q.screen.width <= 650)
const lessThanSixhundred = computed( () => $q.screen.width <= 600)
const gtFourThreeFive = computed( () => $q.screen.width > 435)
const lteFourThreeFive = computed( () => $q.screen.width <= 435)
const loader = ref<boolean>(false);
const statisticsLoader = ref<boolean>(true);
const akwadLoader = useLoaderStore();
const router = useRouter();
const searchStore = useSearchStore();
const url = ref<string>('');
const resultArr = ref<ISearchAutoComplete[]>([]);
const homeStatsData = ref<ISiteCards>();
const searchList = ref<HTMLElement | null>(null);
const showResults = ref(false);
const activeIndex = ref(-1);
const minChars = 3;
let cancelToken: AbortController | null = null;

const faqList = reactive([
    {
        question: '1. ' + 'كيف أشارك تجربتي؟ ',
        answer: 'عن طريق استخدام أداة أكواد "يمكنك تحميلها من متجر جوجل" <a href="https://chromewebstore.google.com/detail/akwad-ux-tool/moimamimapjopaapamoiciljeocjfddl" target="_blank">هنا</a>'
    },
    {
        question: '2. ' + 'هل يتم مراجعة التعليقات قبل نشرها؟',
        answer: 'نعم، نراجع كل التعليقات للتأكد من التزامها بالمعايير'
    }, 
    {
        question: '3. ' + 'كيف أنشئ حساب؟',
        answer: 'بسيطة! اضغط على "إنشاء حساب" واملأ البيانات المطلوبة',
    },
    {
        question: '4.' + 'وش نوع التعليقات اللي أقدر أنشرها؟',
        answer: 'تجاربك، اقتراحاتك، أو ملاحظاتك أو المشاكل اللي واجهتك بشرط تكون بناءة وغير مسيئة',
    },
    {
        question: '5. ' + 'هل أقدر أعدل تعليقي؟',
        answer: 'نعم، تقدر تعدل تعليقك بعد النشر في أي وقت'
    },
    {
        question: '6. ' + 'وش نوع المواقع اللي أقدر أقيمها؟',
        answer: 'تقدر تقيم أي موقع تبيه'
    }
]);

const handleInput = async () => {
  if (url.value.length < minChars) {
    showResults.value = false;
    return;
  }
  if (cancelToken) {
    cancelToken.abort();
  }
  cancelToken = new AbortController();

  try {
    const results = await autoComplete(url.value, {
      signal: cancelToken.signal,
    });
    resultArr.value = results.data;
    showResults.value = true;
    activeIndex.value = -1;

    setTimeout(() => {
      handleScroll();
    });
  } catch (error: any) {
    // handleErrorFunc(error)
  }
};

const handleKeydown = (e: KeyboardEvent) => {
  if (e.key === 'ArrowDown') {
    e.preventDefault();
    navigateResults(1);
  } else if (e.key === 'ArrowUp') {
    e.preventDefault();
    navigateResults(-1);
  } else if (e.key === 'Enter') {
    e.preventDefault();
    if (url.value.includes('http')) {
      if(url.value.length > 256){
      MyToaster.error('ما بيصير كلمة البحث تزيد عن 256 حرف');
      loader.value = false;
      return;
    }
      router.push(`/result/${url.value}?page=1`);
    } else if (activeIndex.value !== -1) {
      selectResult();
    } else {
      getAllSearchResults();
    }
  }
};

const selectResult = () => {
  if (activeIndex.value !== -1) {
    url.value = resultArr.value[activeIndex.value].url;
    showResults.value = false;
    activeIndex.value = -1;
    onSearch();
  }
};

const navigateResults = (direction: number) => {
  activeIndex.value =
    (activeIndex.value + direction + resultArr.value.length) %
    resultArr.value.length;
};

const onSearch = async () => {
  try {
    loader.value = true;
    akwadLoader.show();

    const res = await search(url.value);
    searchStore.setKey(res.data.key);
    searchStore.setUrl(res.data.url);
    router.push(`/result/${res.data.origin_link}?page=1`);
    loader.value = false;
  } catch (error: any) {
    handleErrorFunc(error);
    loader.value = false;
  }
};

const getAllSearchResults = async () => {
  if(!url.value){
    MyToaster.error('ما بيصير كلمة البحث تقل عن 3 حروف');
    return;
  }
  if(url.value.length > 256){
      MyToaster.error('ما بيصير كلمة البحث تزيد عن 256 حرف');
      loader.value = false;
      return;
  }
  try {
    loader.value = true;
    akwadLoader.show();
    if (url.value.includes('http')) {
      router.push(`/result/${url.value}?page=1`);
    } else {
      router.push({
        name: 'SearchResultsPage',
        query: {
          term: url.value,
          page: '1',
        },
      });
    }

    loader.value = false;
  } catch (error: any) {
    handleErrorFunc(error);
    loader.value = false;
  }
};

const goTo = (url: string) => {
  akwadLoader.show();
  router.push(`/result/${url}?page=1`);
};

const handleClickOutside = (event: MouseEvent) => {
  const searchInput = document.querySelector('.search-section__input');
  if (searchInput && !searchInput.contains(event.target as Node)) {
    showResults.value = false;
    resultArr.value = [];
  }
};

const getHomeStatistics = () => {
  try {
    // const res = await randomSites();
    // res.data.random_top_websites = res.data?.random_top_websites.slice(0, 5);
    // homeStatsData.value = res.data;
      homeStatsData.value = searchStore.getRandomSites();
      statisticsLoader.value = false;
  } catch (error: any) {
    handleErrorFunc(error);
  }
};

const handleScroll = () => {
  if (searchList.value) {
    const rect = searchList.value.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    // Check if the div is in the bottom half of the page
    if (rect.top + rect.height > windowHeight && rect.top < windowHeight) {
      scrollToTarget();
    }
  }
};

const scrollToTarget = () => {
  if (searchList.value) {
    const rect = searchList.value.getBoundingClientRect();
    const scrollPosition = window.scrollY + rect.top - 150; // Adjust for slight offset
    window.scrollTo({
      top: scrollPosition,
      behavior: 'smooth',
    });
  }
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
  getHomeStatistics();
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});

const getResponsiveImageUrl = (imagePath?: string): string => {
  if (!imagePath) return '/website-dummy.jpg';

  // Split the path and filename
  const lastDotIndex = imagePath.lastIndexOf('.');
  const basePath = imagePath.slice(0, lastDotIndex);
  const extension = imagePath.slice(lastDotIndex);

  // Add _thumb suffix for screens <= 1024px
  // const suffix = lteThanOneZeroTwoFour.value ? '_thumb' : '';
  const suffix = '_thumb';

  return `${APP_BASE_URL}/${basePath}${suffix}${extension}`;
};
</script>
<style scoped>
  .image-step {
    border-radius: 10px;
    box-shadow: 1px 1px 4px 2px #ddd;
    width: 180px;
  }
  .box-steps .q-card .number {
    bottom: -12%;
  }
  .box-steps .q-card {
    outline: 1px solid #ededed;
    box-shadow: none;
    padding: 4px ;
  }
  .box-steps .q-card .q-card__section {
    padding: 6px ;
  }
  .box-steps .q-card {
    height:100%;
  }

  .number-step {
    font-size: 1.7rem;
    color: #5854ff;
    font-weight: bolder;
    font-family: tahoma;
    width: 40px;
    height: 40px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #5854ff;
}

</style>
